module.exports = __webpack_public_path__ + "static/media/mini-logo.45a015f8.svg";